import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationPaymentTypesActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/PaymentType/PaymentTypeBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationPaymentTypes"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationPaymentTypes"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationPaymentTypesActivity)
